import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentSection, InstructionStepper, SectionHeading } from '@vwfs-bronson/bronson-react';

interface Props {
  formData?: any;
}

export const IdentSuccessForCoApplicantEmailPage: FunctionComponent<Props> = () => {
  const { t } = useTranslation();

  return (
    <>
      {/* <ContentSection pageWrap>
        <ShoppingCart formData={formData} dataTheme="default" />
      </ContentSection> */}
      <ContentSection pageWrapSize="small">
        <SectionHeading level={3}>{t('identSuccessPage:coApplicantEmailPage:title')}</SectionHeading>
      </ContentSection>
      <ContentSection pageWrap pageWrapSize="medium">
        <InstructionStepper
          statusActiveText={t('app:instructionStepper:activeLabel')}
          statusNotActiveText={t('app:instructionStepper:nonActiveLabel')}
        >
          <InstructionStepper.Step icon="document" title={t('identSuccessPage:instructions:upload')} />
          <InstructionStepper.Step
            icon="checkmark"
            state="is-active"
            title={t('identSuccessPage:instructions:analysis')}
          />
          <InstructionStepper.Step icon="pen" title={t('identSuccessPage:instructions:sign')} />
          <InstructionStepper.Step icon="semantic-calendar" title={t('identSuccessPage:instructions:vehicle')} />
        </InstructionStepper>
      </ContentSection>
    </>
  );
};
